exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "h1 {\n  text-align: center;\n  font-family: fantasy;\n}\n\na {\n  text-decoration: none;\n  color: black;\n}\n\n#shop-now {\n  display: table;\n  margin: 1em auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/page_components/welcome/welcome.component.css
// module id = 379
// module chunks = 1